import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}
function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}
function cfg() { return { headers: getAuthHeaders(), timeout: 15000 }; }

export async function fetchEscoposApi() {
  const base = getBase(); if (!base) return [];
  try { const r = await axios.get(base + '/api-chaves/escopos', cfg()); return Array.isArray(r?.data) ? r.data : []; } catch (_) { return []; }
}
export async function fetchChavesApi() {
  const base = getBase(); if (!base) return [];
  try { const r = await axios.get(base + '/api-chaves', cfg()); return Array.isArray(r?.data) ? r.data : []; } catch (_) { return []; }
}
export async function criarChaveApi(body) {
  const base = getBase(); if (!base) throw new Error('Backend não configurado');
  const r = await axios.post(base + '/api-chaves', body, cfg());
  return r?.data ?? null;
}
export async function atualizarChaveApi(id, body) {
  const base = getBase(); if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/api-chaves/' + id, body, cfg());
}
export async function revogarChaveApi(id) {
  const base = getBase(); if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/api-chaves/' + id, cfg());
}
